import { vuexSimple } from '@/helpers';
import media from '@/store/media';
export default vuexSimple(
  {
    ...media
  },
  {
    // tags: null,
    collapse: true,
    tags: {},
    selectedTags: {},
    sectors: [],
    selectedSectors: [],
    types: [],
    categories: [],
    selectedCategories: [],
    sourceIds: [],
    selectedSourceIds: {},
    duration: [0, 50],
    age: [0, 5],
    sentiment: [0, 5],
    interestingness: [0, 5],
    visuality: [0, 5],
    sourcePopularity: [0, 5],
    default_duration: null,
    default_age: null,
    default_sentiment: null,
    default_interestingness: null,
    default_visuality: null,
    default_sourcePopularity: null
  }
);
